import { render } from "./TradeOrderContainerM.vue?vue&type=template&id=34b6ed28"
import script from "./TradeOrderContainerM.vue?vue&type=script&lang=js"
export * from "./TradeOrderContainerM.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__